import {useRequiredConfig} from '@domain/shifthandover'
import {FilterDatePicker} from '@hconnect/common/components'
import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {useUpmPlantNow} from '@hconnect/upm'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST} from '../consts'
import {useTimeRangeParam} from '../hooks'

type Props = {
  plantId: string
}

export const OptimizationSpecialistFilterContainer = ({plantId}: Props) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)

  const {shifts, timezone} = useRequiredConfig(plantId)
  const {timeRange, setTimeRange} = useTimeRangeParam({
    defaultTimeRange: 'pastShift',
    key: 'timeRange',
    timezone: timezone
  })

  const onChange = (param: ShiftQuickSelectSlots | DateRange) => {
    setTimeRange(param)
  }

  const getPlantNow = useUpmPlantNow(plantId)

  return (
    <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
      <FilterDatePicker
        shifts={shifts}
        timezone={timezone}
        defaultTimeRange={'pastShift'}
        plantNow={getPlantNow()}
        onChange={onChange}
        value={timeRange}
        translate={t}
        language={language}
        quickSelectSlots={SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST}
      />
    </Box>
  )
}
